import React from 'react'
import CardReactFormContainer from 'card-react'
import { Input } from 'antd'
// import _get from 'lodash/get'
import { injectIntl } from 'react-intl'
import '~/lib/css/card.css'

@injectIntl
class CardInput extends React.Component {
  state = {
    number: '',
    name: '',
    expiry: '',
    cvc: ''
  }
  handleChange = (e) => {
    const { id, value } = e.target
    let _value = value
    if (id === 'number' && _value.length > 0) {
      _value = _value.replace(/\D/g, '')
      _value = _value.slice(0, 16)
      _value = _value.match(/.{1,4}/g).join(' ')
    }
    if (id === 'expiry') {
      _value = _value.replace(/\D/g, '')
      // _value = _value.replace(/\//g, '')
      _value = _value.slice(0, 6)
      if (_value.length >=2) {
        _value = `${_value.slice(0, 2)} / ${_value.slice(2)}`
      }
    }
    this.setState({
      [id]: _value
    }, () => this.props.onChange(this.state))
  }
  render () {
    const { number, name, expiry, cvc } = this.state
    return <div className="mod-wrapper-card">
      <div id="card-wrapper"></div>
      <CardReactFormContainer
        // the id of the container element where you want to render the card element.
        // the card component can be rendered anywhere (doesn't have to be in ReactCardFormContainer).
        container="card-wrapper" // required
        // an object contain the form inputs names.
        // every input must have a unique name prop.
        formInputsNames={
          {
            number: 'cc_number', // optional — default "number"
            name: 'cc_name', // optional - default "name"
            expiry: 'cc_expiry', // optional — default "expiry"
            cvc: 'cc_cvc' // optional — default "cvc"
          }
        }

        // initial values to render in the card element
        initialValues={
          {
            number: '', // optional — default •••• •••• •••• ••••
            name: '', // optional — default FULL NAME
            expiry: '', // optional — default ••/••
            cvc: '' // optional — default •••
          }
        }
        // the class name attribute to add to the input field and the corresponding part of the card element,
        // when the input is valid/invalid.
        classes={
          {
            valid: 'valid-input', // optional — default 'jp-card-valid'
            invalid: 'invalid-input' // optional — default 'jp-card-invalid'
          }
        }

        // specify whether you want to format the form inputs or not
        // formatting={true} // optional - default true
        formatting={false} // optional - default true
      >
        <div className="block">
          <Input placeholder={this.props.intl.formatMessage({ id: 'app.cardNumber' })} name="cc_number" id="number" value={number} onChange={this.handleChange} required />
          <Input placeholder={this.props.intl.formatMessage({ id: 'app.nameOnCard' })} name="cc_name" id="name"  value={name} onChange={this.handleChange} required />
          <Input.Group compact>
            <Input placeholder={this.props.intl.formatMessage({ id: 'app.expirationDate' })} name="cc_expiry" id="expiry"  value={expiry} onChange={this.handleChange} required />
            <Input placeholder={this.props.intl.formatMessage({ id: 'app.securityCode' })} name="cc_cvc" id="cvc"  value={cvc} className="ant-input" onChange={this.handleChange} required type="number" pattern="\d*" />
          </Input.Group>
        </div>
      </CardReactFormContainer>
    </div>
  }
}
export default CardInput



// WEBPACK FOOTER //
// ./src/App/components/PaymentBlocks/OmiseCard/CardInput.js